import { FC, useContext, useEffect } from "react";
import { useLocation } from "react-router";
import { ThemeSelectorContext } from "@/context";
import { getClientID } from "@/utils";

export const DynamicFavicon: FC = () => {
  const location = useLocation();
  const { favicon } = useContext(ThemeSelectorContext);
  const client = getClientID();

  useEffect(() => {
    updateFavicon();
    updateTitle();
  }, [location]);

  const updateFavicon = () => {
    if (!favicon) return;

    const faviconElement = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    if (faviconElement) {
      faviconElement.href = favicon;
    }
  };

  const updateTitle = () => {
    const title = getTitle();
    document.title = title;
  };

  const getTitle = () => {
    return !client ? "Health Care Portal | Judi Health" : "Health Care Portal";
  };

  return null;
};

export default DynamicFavicon;
